export default __webpack_public_path__ + "static/media/n.9e592892.wav";